module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (255).f0f85177.jpg";